import type * as React from 'react';
import { Box, Typography } from 'ui';

import { StyledAnchor, StyledLink } from './styles';

type BaseProps = {
  label: string;
  icon: React.ReactNode;
  description: string;
};

type InternalLinkProps = BaseProps & {
  to: string;
  href?: never;
};

type ExternalLinkProps = BaseProps & {
  href: string;
  to?: never;
};

type Props = InternalLinkProps | ExternalLinkProps;

export const TabNavigationItem = ({ label, icon, href, to, description }: Props) => {
  const content = (
    <Box
      height="100%"
      p={2}
      borderRadius={2}
      boxSizing={'border-box'}
      sx={{
        ':hover': {
          backgroundColor: '#f5f5f5',
        },
        backgroundColor: '#fff',
      }}
    >
      <Box
        mb={1}
        sx={{
          '& svg': {
            fontSize: 30,
          },
          color: 'rgb(108, 117, 125)',
        }}
      >
        {icon}
      </Box>
      <Box mb={1}>
        <Typography variant="h6" fontSize={15} fontWeight={700} color={'black'}>
          {label}
        </Typography>
      </Box>
      <Typography variant="subtitle2">{description}</Typography>
    </Box>
  );

  if (to) {
    return <StyledLink to={to}>{content}</StyledLink>;
  }

  return <StyledAnchor href={href}>{content}</StyledAnchor>;
};
